import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from '@mui/material';
import { MdPlayArrow } from '@teamworksdev/icons';
import { useState } from 'react';
import { environment } from '../../../../environment';
import { PageHeader } from '../../../components/layout/page-header';

type BedrockSmokeResult =
  | { ok: true; text: string }
  | { ok: false; error: string };

export function AiPage() {
  const [isRunning, setIsRunning] = useState(false);
  const [result, setResult] = useState<BedrockSmokeResult | null>(null);

  const onRunSmoke = async () => {
    setIsRunning(true);
    setResult(null);
    try {
      const response = await fetch(
        `${environment.VITE_API_URL}/internal/bedrock-smoke`,
        {
          method: 'POST',
          credentials: 'include',
        },
      );

      let body: { ok?: boolean; text?: string; error?: string } | null = null;
      try {
        body = await response.json();
      } catch {
        // 401 sends a plain-text body, not JSON
      }

      if (body?.ok && typeof body.text === 'string') {
        setResult({ ok: true, text: body.text });
      } else if (typeof body?.error === 'string') {
        setResult({ ok: false, error: body.error });
      } else {
        setResult({
          ok: false,
          error:
            response.status === 401
              ? 'Not authorized'
              : 'Bedrock Converse failed',
        });
      }
    } catch {
      setResult({ ok: false, error: 'Bedrock Converse failed' });
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <div className="flex flex-col h-full overflow-auto">
      <PageHeader title="AI" />
      <div className="flex flex-col gap-6 p-6">
        <Paper className="p-6">
          <Typography variant="h2" className="mb-2">
            Bedrock smoke
          </Typography>
          <Typography variant="body2" className="mb-4">
            Runs a one-shot Converse call through Platform BaaS (AssumeRole +
            AIP) to confirm UAT wiring. Not a product chat feature.
          </Typography>
          <Box className="flex flex-col gap-4">
            <Box>
              <Button
                variant="contained"
                onClick={onRunSmoke}
                disabled={isRunning}
                startIcon={
                  isRunning ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <MdPlayArrow />
                  )
                }
              >
                {isRunning ? 'Running...' : 'Run Bedrock smoke'}
              </Button>
            </Box>

            {result?.ok === true && (
              <Alert severity="success">
                Bedrock Converse succeeded
                {result.text ? `: ${result.text}` : ''}
              </Alert>
            )}

            {result?.ok === false && (
              <Alert severity="error">{result.error}</Alert>
            )}
          </Box>
        </Paper>
      </div>
    </div>
  );
}
